import React, { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { FormControlLabel, Typography, InputLabel, Select } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 224,
      width: 250,
    },
  },
};

export default function RadioButtonsGroup({
  selectedData,
  setSelectedData,
  selectedGroups,
  setSelectedGroups,
  apiCall,
  data,
  dropdown,
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [closeGroup, setCloseGroup] = useState(false);
  const radioButton = [
    {
      name: 'All Viewers',
      value: 2,
    },
    { name: 'Only I can View (Private)', value: 1 },
    { name: 'Choose a group to share with', value: 3 },
  ];
  useEffect(() => {
    apiCall();
  }, []);
  const handleRadioChange = (event) => {
    const value = Number(event.target.value);
    setSelectedData(value);
    setCloseGroup(value === 3); // true if 3, else false
  };

  const handleGroupChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedGroups(typeof value === 'string' ? value.split(',') : value);
  };
  useEffect(() => {
    if (selectedData === 3) {
      setDropdownOpen(true); // Open when visibility is "Choose a group"
    } else {
      setDropdownOpen(false);
    }
  }, [selectedData]);
  console.log('groupdata', data);
  return (
    <>
      {dropdown ? (
        <FormControl fullWidth sx={{ width: 200, mt: 3 }}>
          <InputLabel
            sx={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
            id="visibility-label"
          >
            Visibility
          </InputLabel>
          <Select
            labelId="visibility-label"
            id="visibility-select"
            value={selectedData}
            label="Visibility"
            sx={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
            onChange={handleRadioChange}
          >
            {radioButton.map((obj, i) => {
              if (obj.value === 3) {
                return (
                  <MenuItem key={obj.value} value={obj.value}>
                    {selectedGroups && selectedGroups.length > 0
                      ? data
                          .filter((group) => selectedGroups.includes(group.id))
                          .map((group) => group.title)
                          .join(', ')
                      : obj.name}
                  </MenuItem>
                );
              }

              return (
                <MenuItem key={obj.value} value={obj.value}>
                  {obj.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      ) : (
        <FormControl fullWidth sx={{ mt: 3 }}>
          <FormLabel
            id="demo-radio-buttons-group-label"
            sx={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '16px',
              color: '#000000',
              fontWeight: 'bold',
            }}
          >
            Visibility
          </FormLabel>

          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={selectedData}
            onChange={handleRadioChange}
          >
            {radioButton?.map((item) => {
              const isGroupOption = item?.value === 3;

              const labelText = isGroupOption
                ? selectedGroups && selectedGroups.length > 0
                  ? data?.filter((group) => selectedGroups?.includes(group?.id))
                      .map((group) => group?.title)
                      .join(', ')
                  : item?.name
                : item?.name;

              return (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio />}
                  label={(
                    <Typography
                      sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '14px',
                        color: '#000000',
                        fontWeight: '500',
                      }}
                    >
                      {labelText}
                    </Typography>
                  )}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      )}

      {/* Show MultiSelect if visibility === 3 */}
      {closeGroup && data?.length > 0 && (
        <FormControl sx={{ mt: 2, width: 200 }}>
          <InputLabel id="group-multi-select-label">Select Groups</InputLabel>
          <Select
            labelId="group-multi-select-label"
            id="group-multi-select"
            multiple
            value={Array.isArray(selectedGroups) ? selectedGroups : []}
            onChange={handleGroupChange}
            input={<OutlinedInput label="Select Groups" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
            open={dropdownOpen}
            onClose={() => {
              setDropdownOpen(false);
              setCloseGroup(false); // Also close the group selector on outside click
            }}
            onOpen={() => setDropdownOpen(true)}
          >
            <MenuItem
              onClick={() => {
                setCloseGroup(false);
                setDropdownOpen(false); // also close the dropdown
              }}
              sx={{
                justifyContent: 'end',
                fontWeight: 'bold',
              }}
            >
              ✕
            </MenuItem>
            {data?.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                <Checkbox checked={selectedGroups?.includes(group.id)} />
                <ListItemText primary={group.title} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
}
